import { parseCallHangupPayload } from '../../infrastructure/adapters/voiceSocketEventAdapter';
import { voiceRemoveIncomingCall, voiceReleaseCallSession, voiceSetError } from '../../../../../actions/voice/voiceActions';
import { hangupCurrentAgentCall } from '../../infrastructure/webrtc/voiceAgentWebRtcAdapter';
import {
  completeVoiceCallHangup,
  getVoiceTabClaimedCallControlId,
  isVoiceHangupInFlight,
  isVoiceHangupPosted,
  resolveEndedReasonForVoiceCall
} from '../voiceHangupCoordinator';
import { isHangupOwnedByThisTab } from '../../domain/voiceTabCallOwnership';
import { voiceSocketLog } from '../../../../utils/voiceSocketDebug';

export default function callHangupHandler(payload, ports) {
  const parsed = parseCallHangupPayload(payload);
  if (!parsed) {
    voiceSocketLog('call_hangup ignored (invalid payload)', payload);
    return;
  }

  const {
    activeCall,
    incomingCalls,
    outboundDialingCall
  } = ports.getHandlerState();
  const isTrackedIncoming = incomingCalls.some(
    (call) => call.callControlId === parsed.callControlId
  );
  const isOutboundDialingHangup = outboundDialingCall?.callControlId === parsed.callControlId;
  const ownedByThisTab = isHangupOwnedByThisTab({
    callControlId: parsed.callControlId,
    activeCallControlId: activeCall?.callControlId ?? null,
    outboundDialingCallControlId: outboundDialingCall?.callControlId ?? null,
    thisTabClaimedCallControlId: getVoiceTabClaimedCallControlId()
  });

  voiceSocketLog('dispatch call_hangup', {
    callControlId: parsed.callControlId,
    activeCallId: activeCall?.callControlId,
    claimedCallControlId: getVoiceTabClaimedCallControlId(),
    isTrackedIncoming,
    isOutboundDialingHangup,
    ownedByThisTab
  });

  ports.dispatch(voiceRemoveIncomingCall(parsed.callControlId));

  if (!ownedByThisTab) {
    voiceSocketLog('call_hangup ring only (not this tab)', parsed.callControlId);
    return;
  }

  const resetAfterHangup = () => {
    ports.dispatch(voiceReleaseCallSession(parsed.callControlId));
    if (isOutboundDialingHangup) {
      const cause = parsed.hangupCause ?? '';
      if (cause && cause !== 'NORMAL_CLEARING') {
        ports.dispatch(voiceSetError(
          `Llamada finalizada (${cause.replace(/_/g, ' ').toLowerCase()})`
        ));
      }
    }
  };

  if (isVoiceHangupInFlight(parsed.callControlId)) {
    voiceSocketLog('call_hangup deferred (hangup POST in flight)', parsed.callControlId);
    return;
  }
  if (isVoiceHangupPosted(parsed.callControlId)) {
    hangupCurrentAgentCall().catch(() => {});
    resetAfterHangup();
    return;
  }
  const endedReason = resolveEndedReasonForVoiceCall({
    activeCallControlId: activeCall?.callControlId ?? null,
    outboundDialingCallControlId: outboundDialingCall?.callControlId ?? null
  }, parsed.callControlId);
  completeVoiceCallHangup({
    callControlId: parsed.callControlId,
    endedReason,
    onAfterHttpOk: resetAfterHangup
  }).catch((error) => {
    voiceSocketLog('call_hangup POST failed', {
      callControlId: parsed.callControlId,
      message: error instanceof Error ? error.message : String(error)
    });
  });
}
